import React, { useEffect } from 'react';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import VTCLanding from './components/VTCLanding';
import LocationVTCIDF from './components/LocationVTCIDF';
import LocationToyotaCHR from './components/LocationToyotaCHR';
import LocationVoitureUber from './components/LocationVoitureUber';

function App() {
  // Aggressively remove any injected badges
  useEffect(() => {
    const removeBadge = () => {
      // Multiple selectors to catch all variations
      const selectors = [
        '#emergent-badge',
        '[id*="emergent"]',
        '[id*="Emergent"]',
        '[class*="emergent"]',
        'a[href*="emergent.sh"]',
        'a[href*="emergent.com"]',
        'a[href*="emergentagent"]'
      ];
      
      selectors.forEach(selector => {
        try {
          document.querySelectorAll(selector).forEach(el => {
            el.remove();
          });
        } catch (e) {}
      });
      
      // Also check for fixed position elements at bottom-right (typical badge position)
      document.querySelectorAll('body > a').forEach(el => {
        const style = el.getAttribute('style') || '';
        if (style.includes('fixed') && style.includes('bottom') && style.includes('right')) {
          el.remove();
        }
        if (style.includes('z-index: 9999')) {
          el.remove();
        }
      });
    };
    
    // Remove immediately
    removeBadge();
    
    // Remove after short delay (for late injections)
    setTimeout(removeBadge, 100);
    setTimeout(removeBadge, 500);
    setTimeout(removeBadge, 1000);
    setTimeout(removeBadge, 2000);
    
    // Observe for dynamic injection
    const observer = new MutationObserver(() => {
      removeBadge();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => observer.disconnect();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<VTCLanding />} />
        <Route path="/location-vtc-ile-de-france" element={<LocationVTCIDF />} />
        <Route path="/location-voiture-vtc-toyota-chr" element={<LocationToyotaCHR />} />
        <Route path="/location-voiture-uber-idf" element={<LocationVoitureUber />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
